import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { LucideIcon } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
export const CommandLabel = t0 => {
  const $ = _c(6);
  const {
    children,
    icon: Icon,
    iconClassName
  } = t0;
  let t1;
  if ($[0] !== Icon || $[1] !== iconClassName) {
    t1 = Icon && <Icon className={cn("size-4 shrink-0 text-muted-foreground", iconClassName)} />;
    $[0] = Icon;
    $[1] = iconClassName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <span className="flex items-center gap-2" data-sentry-component="CommandLabel" data-sentry-source-file="command-label.tsx">{t1}{children}</span>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};